export enum RoleEnum {
    ADMIN = 'Admin',
    KTV = 'Ktv',
    CUSTOMER = 'Customer',
}
